import Vuex from "vuex";
import properties from "./properties/properties";
import support from "./support/support";

export default new Vuex.Store({
    modules: {
        properties,
        support
    }
});